<script lang="ts">
    import { getTypedContext } from "@lib/svelte-typed-context";

    import { videoControllerToken } from "./context_tokens";

    const videoController = getTypedContext(videoControllerToken);

    const duration$ = videoController.formatedDuration$;
    const time$ = videoController.formatedTime$;
</script>

<div class="gw-vp-time-progress">
    <div
        class="gw-vp-time-progress_time gw-vp-time-progress__current_time"
        aria-label="Current time"
    >
        {$time$}
    </div>
    <span class="gw-vp-time-progress__separator">/</span>
    <div
        class="gw-vp-time-progress_time gw-vp-time-progress__duration"
        aria-label="Duration"
    >
        {$duration$}
    </div>
</div>

<style>
    .gw-vp-time-progress {
        display: flex;
        color: var(--gw-vp-current-time-color);
        font-size: var(--gw-vp-current-time-font-size);
        font-weight: var(--gw-vp-current-time-font-weight);
    }
    .gw-vp-time-progress__separator {
        margin: 0 0.1rem;
    }
</style>
